import { Text } from '@change/ds-core-ui';

import type { PageHeaderTitleProps } from '../../types';

export const PageHeaderTitle: React.FC<PageHeaderTitleProps> = ({ image, title }: PageHeaderTitleProps) => {
	return (
		<div
			data-testid="page-header-title"
			className="md:auto flex h-12 w-full shrink-0 grow basis-0 flex-row items-center gap-(--space-3,12px) md:gap-(--space-3-5,14px)"
		>
			{image}
			<Text
				data-testid="page-header-text"
				as="h1"
				truncate
				className="color-[var(--color-typography-strong,#403A49)] text-size-heading-xxs line-clamp-2! flex-1 shrink-0 grow basis-0 whitespace-break-spaces!"
			>
				{title}
			</Text>
		</div>
	);
};
